// One window per guide, whoever opens it.
//
// A guide is read ALONGSIDE the page it describes, which is why these open in a popup rather than
// routing to them -- navigating away would lose the reader's place. The window is NAMED so that
// pressing the book icon twice focuses the guide already open instead of stacking up copies of it.
//
// THE NAME HAS TO BE THE SAME EVERYWHERE, and that is what this file is for. Twenty call sites had
// written it out by hand -- "cresReportingDocs", "cresEnterpriseTermsDocs" -- and every one of
// them agreed, because the convention was obvious. Then the Documentation page invented a second
// one, `cresDocs_reporting.html`, and opening the guide from the index and from the builder
// gave two windows of the same document, each scrolled somewhere different.
//
// So the convention is written down and derived, not remembered: reporting.html becomes
// cresReportingDocs, and there is nowhere left to disagree. guideWindow.test.ts checks the
// derivation against every name the app has written by hand, so a call site that keeps its literal
// is still held to it.
//
// NOT _blank. HomeLanding opens guides that way on purpose: it is the marketing page, its reader is
// anonymous and has no app to read the guide beside, and a plain tab is the right thing there.

const FEATURES = "width=1200,height=900,scrollbars=yes,resizable=yes";

/** cresReportingDocs, from reporting.html. A hash is not part of the identity: the guide
 *  is one document, and a deep link re-anchors the window rather than earning its own. */
export function guideWindowName(file: string): string {
    const base = file.split("#")[0].replace(/^.*\//, "").replace(/\.html$/, "");
    const pascal = base.split("-").filter(Boolean)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join("");
    return `cres${pascal}Docs`;
}

/**
 * Open a guide, optionally at one of its sections.
 *
 * Takes either the bare file ("reporting.html") or a whole path with a hash
 * ("/docs/reporting.html#hierarchies") -- the two forms the app already writes.
 */
export function openGuide(fileOrPath: string): Window | null {
    const file = fileOrPath.replace(/^\/docs\//, "");
    return window.open(`/docs/${file}`, guideWindowName(file), FEATURES);
}
